import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'
import Menu from 'component/menu/Menu'
import logo from 'images/logo.svg'

const Header = ({ auth, menu, logout, translate }) => {
  const handleLogoutClick = (event) => {
    event.preventDefault()
    logout()
  }

  const renderLogout = () => (
    <nav className='navigation-tools'>
      <li className='navigation-tools-item'>
        <a href='#' onClick={handleLogoutClick}>
          <i className='glyph glyph-silhouette' />
          <span className='navigation-tools-title'>
            {translate('option.exit')}
          </span>
        </a>
      </li>
    </nav>
  )

  const renderMenu = () => (
    <Menu menu={menu} user={auth.user} translate={translate} />
  )

  return (
    <header className='main-header navigation'>
      {auth.isAuthenticated && renderMenu()}

      <Link to='/' className='logo'>
        <img className='image' src={logo} />
      </Link>

      {auth.isAuthenticated && renderLogout()}
    </header>
  )
}

Header.propTypes = {
  auth: PropTypes.object.isRequired,
  logout: PropTypes.func,
  menu: PropTypes.object,
  translate: PropTypes.func.isRequired,
}

export default Header
